export default "__VITE_ASSET__6574b8fc__"